import {Pipe, PipeTransform} from '@angular/core';
import {LocalizationService} from './localization.service';

@Pipe({
  name: 'localize',
  pure: true,
  standalone: true
})
export class LocalizationPipePipe implements PipeTransform {

  constructor(private readonly localeService: LocalizationService) {
  }

  transform(value: string, ...args: unknown[]): string {
    return this.localeService.getTranslation(value);
  }

}
